module.exports = __webpack_public_path__ + "static/media/logo_kastalani.c91b7d34.png";